// extracted by mini-css-extract-plugin
export default {"folderCardContainer":"AddFolderCard_folderCardContainer__E5GAA","folderCard":"AddFolderCard_folderCard__xHlcv","addFolderIcon":"AddFolderCard_addFolderIcon__5hjVS"};